<template>
  <div v-else>
    <Header colorIcons="white" />
    <div class="home-container">
      <parallax-container class="parallax-box">
        <parallax-element :parallaxStrength="-5" :type="'depth'" style="width: 100%; height: 100%">
          <div class="home"></div>
        </parallax-element>
      </parallax-container>
      <div class="text">
        <div class="text__title">
          <div class="text__title-name">
            <p>A<span>N</span><span>N</span>A</p>
          </div>
          <div class="text__title-surname">
            <h2>WALENTYNOWICZ</h2>
            <div class="text__title-surname-bottomline"></div>
          </div>
        </div>

        <div class="text__date">15.08.1929 - 10.04.2010</div>
        <p
          class="text__quote"
        >Czuwać, aby nie było ludzi skrzywdzonych, aby podać rękę każdemu, który nie umie sobie poradzić. […] Może sama zbyt wiele łez wylałam w życiu, chciałabym, żeby z mojego powodu ktoś choć o jeden raz w życiu więcej się uśmiechnął”</p>
        <span class="text__footnote">Anna Walentynowicz, Polskie Radio, 9.09.1980</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueMouseParallax from "vue-mouse-parallax";

import Header from "../Header/Header";


Vue.use(VueMouseParallax);

export default {
  name: "Home",

  props: {
    msg: String
  },
  components: {
    Header
  }
};
</script>

<style lang="scss" scoped>
.home-container {
  color: #f5edea;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;
}

.parallax-box {
  position: absolute;
  top: -5%;
  left: -5%;
  right: -5%;
  bottom: -5%;
  width: 110%;
  height: 110%;
  background: black;

  @media (max-width: 1024px) {
    top: 0%;
    left: 0%;
    right: 0%;
    bottom: 0%;
    width: 100%;
    height: 100vh;
  }
}

.home {
  background: url("../../assets/hero_background.jpg");
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 100%;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: fadeIn 3s;
}

.text {
  width: 41.1rem;
  text-shadow: 2px 2px 8px #000;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 13rem;
  opacity: 0;

  @keyframes textFade {
    0% {
      opacity: 0;
      /* transform: translateY(-50%) translateX(50rem); */
    }
    100% {
      opacity: 1;
      /* transform: translateY(-50%) translateX(0); */
    }
  }

  animation: textFade 2s ease-in-out 1.2s forwards;

  &__title {
    font-family: "Oswald", sans-serif;
    display: flex;
    flex-direction: column;
    position: relative;
    font-weight: bold;

    p {
      position: relative;
      font-family: "Open Sans Condensed", sans-serif;
      font-size: 10rem;
      font-weight: bold;
      /* letter-spacing: 5.97rem; */
      display: block;
      line-height: 8rem;
      z-index: -1;
      border-bottom: 0.5rem solid #f5edea;
      margin: 0;
      padding: 0;
      span:first-child {
        margin: 0 5.97rem;
      }
      span:nth-child(2) {
        margin-right: 5.97rem;
      }
    }

    h2 {
      font-size: 5.85rem;
      letter-spacing: 0.15rem;
      font-weight: bold;
      border-bottom: 0.4rem solid #f05a42;
      padding-bottom: 0.7rem;
    }
  }

  &__date {
    font-family: "Poppins", sans-serif;
    font-size: 1.5rem;
    margin-top: 2.5rem;
    margin-bottom: 1.5rem;
  }

  &__quote {
    font-family: "Poppins", sans-serif;
    font-size: 0.8rem;
    line-height: 1.5rem;
    width: 100%;
  }

  &__footnote {
    display: inline-block;
    font-family: "Poppins", sans-serif;
    font-style: italic;
    font-size: 0.7rem;
    margin-top: 1.875rem;
    color: #979698;
  }
}
</style>
